import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2)
  },
  searchInput: {
    width: '100%'
  },
  scopeHint: {
    display: 'block',
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary
  }
}))

export default useStyles
